/* ドロワー/オーバーレイの位置をヘッダーの表示状態に追従させる（純JS・theme/yappy 共通）。 */
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('.navigation-drawer');
  const overlay = document.querySelector('#header-sidebar-menu::part(overlay)');
  const header = document.querySelector('header'); // ヘッダーの要素
  const announcementBar = document.querySelector('.announcement-bar'); // アナウンスバーの要素

  if (!drawer || !header) return;

  function updateDrawerPosition() {
    const headerRect = header.getBoundingClientRect();
    const headerBottom = headerRect.top + headerRect.height;

    // 画面の高さからヘッダーの位置を引いた値を計算
    const availableHeight = window.innerHeight - headerBottom;

    // ドロワーの高さと位置を設定
    drawer.style.maxHeight = `${availableHeight}px`;
    drawer.style.height = `${availableHeight}px`;
    drawer.style.top = `${headerBottom}px`;

    // オーバーレイの位置も同様に設定
    if (overlay) {
      overlay.style.maxHeight = `${availableHeight}px`;
      overlay.style.top = `${headerBottom}px`;
      overlay.style.height = `${availableHeight}px`;
    }

    // CSSカスタムプロパティを更新
    document.documentElement.style.setProperty('--dynamic-drawer-top', `${headerBottom}px`);
    document.documentElement.style.setProperty('--dynamic-drawer-height', `${availableHeight}px`);
  }

  // スクロールイベントとリサイズイベントで位置を更新
  window.addEventListener('scroll', updateDrawerPosition);
  window.addEventListener('resize', updateDrawerPosition);

  // 初期位置の設定
  updateDrawerPosition();

  // IntersectionObserverでアナウンスバーの可視性を監視
  if (announcementBar) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(() => {
          updateDrawerPosition();
        });
      },
      {
        threshold: [0, 1],
      }
    );

    observer.observe(announcementBar);
  }
});
